import { CustomCardSkeleton } from "./customCardSkeleton";
import { CustomChartSkeleton } from "./customChartSkeleton";
import { CustomSwitchSkeleton } from "./customSwitchSkeleton";
import { DataTableSkeleton } from "./dataTableSkeleton";
import { DynamicFieldTableSkeleton } from "./dynamicFieldTableSkeleton";
import { FormikSkeleton } from "./formikSkeleton";
import HeaderSkeleton from "./headerSkeleton";
import { LayoutSkeleton } from "./layoutSkeleton";
import { LabeledValueSkeleton } from "./labeledValueSkeleton";
import { MeterSummaryTileSkeleton } from "./meterSummaryTileSkeleton";
import SidebarSkeleton from "./sidebarSkeleton";
import { Skeleton } from "./skeleton";

export const SkeletonComponents = {
  skeleton: Skeleton,
  customCardSkeleton: CustomCardSkeleton,
  customChartSkeleton: CustomChartSkeleton,
  customSwitchSkeleton: CustomSwitchSkeleton,
  dataTableSkeleton: DataTableSkeleton,
  dynamicFieldTableSkeleton: DynamicFieldTableSkeleton,
  formikSkeleton: FormikSkeleton,
  meterSummaryTileSkeleton: MeterSummaryTileSkeleton,
  labeledValueSkeleton: LabeledValueSkeleton,
  layoutSkeleton: LayoutSkeleton,
  headerSkeleton: HeaderSkeleton,
  sidebarSkeleton: SidebarSkeleton,
};
